import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import type { RechargeState } from '../types/recharge';

export const useRechargeStore = create<RechargeState>()(
  devtools(
    set => ({
      targetMsisdn: null,
      rechargeValues: [],
      selectedRechargeValue: null,
      selectedRechargeValueIndex: null,
      rechargeValueCampaign: null,
      rechargeResult: null,
      recurrenceResult: null,
      pixTransactionId: null,
      pixToken: null,
      pixRechargeValue: null,
      pixIntentionSent: false,
      isPixFastRecharge: false,
      pendingPixRecharge: null,
      pendingPixChecked: false,
      selectedPaymentMethod: null,
      selectedCard: null,
      creditTransactionId: null,

      setTargetMsisdn: targetMsisdn =>
        set({ targetMsisdn }, false, 'setTargetMsisdn'),
      setRechargeValues: rechargeValues =>
        set({ rechargeValues }, false, 'setRechargeValues'),
      setSelectedRechargeValue: (selectedRechargeValue, listIndex = null) =>
        set(
          {
            selectedRechargeValue,
            selectedRechargeValueIndex: listIndex,
          },
          false,
          'setSelectedRechargeValue',
        ),
      setRechargeValueCampaign: rechargeValueCampaign =>
        set({ rechargeValueCampaign }, false, 'setRechargeValueCampaign'),
      setRechargeResult: rechargeResult =>
        set({ rechargeResult }, false, 'setRechargeResult'),
      setRecurrenceResult: recurrenceResult =>
        set({ recurrenceResult }, false, 'setRecurrenceResult'),
      setPixTransactionId: pixTransactionId =>
        set({ pixTransactionId }, false, 'setPixTransactionId'),
      setPixToken: pixToken => set({ pixToken }, false, 'setPixToken'),
      setPixRechargeValue: pixRechargeValue =>
        set({ pixRechargeValue }, false, 'setPixRechargeValue'),
      setPixIntentionSent: pixIntentionSent =>
        set({ pixIntentionSent }, false, 'setPixIntentionSent'),
      setIsPixFastRecharge: isPixFastRecharge =>
        set({ isPixFastRecharge }, false, 'setIsPixFastRecharge'),
      setPendingPixRecharge: pendingPixRecharge =>
        set({ pendingPixRecharge }, false, 'setPendingPixRecharge'),
      setPendingPixChecked: pendingPixChecked =>
        set({ pendingPixChecked }, false, 'setPendingPixChecked'),
      setSelectedPaymentMethod: selectedPaymentMethod =>
        set({ selectedPaymentMethod }, false, 'setSelectedPaymentMethod'),
      setSelectedCard: selectedCard =>
        set({ selectedCard }, false, 'setSelectedCard'),
      setCreditTransactionId: creditTransactionId =>
        set({ creditTransactionId }, false, 'setCreditTransactionId'),
      clearRecharge: () =>
        set(
          {
            targetMsisdn: null,
            rechargeValues: [],
            selectedRechargeValue: null,
            selectedRechargeValueIndex: null,
            rechargeValueCampaign: null,
            rechargeResult: null,
            recurrenceResult: null,
            pixTransactionId: null,
            pixToken: null,
            pixRechargeValue: null,
            pixIntentionSent: false,
            isPixFastRecharge: false,
            pendingPixRecharge: null,
            pendingPixChecked: false,
            selectedPaymentMethod: null,
            selectedCard: null,
            creditTransactionId: null,
          },
          false,
          'clearRecharge',
        ),
    }),
    { name: 'RechargeStore' },
  ),
);
